import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentDeleteFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.001 12A.999.999 0 0 0 14 11V4a1 1 0 0 0-1-1H3c-.552 0-1 .444-1 .996V14l2.167-2H13Zm-2.647-6.146L8.707 7.5l1.647 1.646-.708.708L8 8.207 6.354 9.854l-.708-.708L7.293 7.5 5.646 5.854l.708-.708L8 6.793l1.646-1.647.708.708Z"
    />
  </svg>
);
export default IconCommentDeleteFilledSizeS;
